/**
 * @file Button displayed on onboarding or purchase headers for contactint support.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { SUPPORT_MODAL } from '../../constants/modals';
import HelpBubblesIcon from '../icons/HelpBubblesIcon';
import Button from '../global/Button';

const propTypes = {
  openModal: PropTypes.func.isRequired,
  className: PropTypes.string,
  iconColor: PropTypes.string,
  iconSize: PropTypes.string,
};

const MobileHeaderSupportButton = ({
  openModal,
  className,
  iconColor = '#97caff',
  iconSize = '24',
  ...props
}) => {
  const authenticated = useSelector(({ auth }) => auth.authenticated);

  if (!authenticated) {
    return null; // modal does not work with unauthed users.
  }

  return (
    <Button
      className={`lh-0 ${className || ''}`}
      btnStyle="reset"
      onClick={() => openModal(SUPPORT_MODAL)}
      {...props}
    >
      <HelpBubblesIcon color={iconColor} size={iconSize} />
    </Button>
  );
};

MobileHeaderSupportButton.propTypes = propTypes;

export default MobileHeaderSupportButton;
